module.exports = __webpack_public_path__ + "static/media/tipsiti.c9138b65.png";